module.exports = __webpack_public_path__ + "static/text-1-e600af5bfc09e819e1a835c0241ad3f0.svg";